<template>
    <section class="py-5">
        <div class="container">
            <h3 class="text-dark text-center mb-0">Our Services</h3>
            <div class="row mt-5">
                <div class="col-lg-4 mb-4">
                    <div class="card">
                        <div class="row g-0">
                            <div class="col-md-4">
                                <img src="/assets/images/services/01.jpg" class="img-fluid rounded-start h-100"
                                    alt="Card Image" style="object-fit: cover;">
                            </div>
                            <div class="col-md-8">
                                <div class="card-body">
                                    <h5 class="card-title">Service 01</h5>
                                    <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                        Perspiciatis numquam impedit cupiditate omnis nesciunt dolore delectus quidem
                                        aspernatur ab commodi.</p>
                                    <a href="javascript:void(0)" class="btn btn-dark px-4">Detail</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-4">
                    <div class="card">
                        <div class="row g-0">
                            <div class="col-md-4">
                                <img src="/assets/images/services/02.jpg" class="img-fluid rounded-start h-100"
                                    alt="Card Image" style="object-fit: cover;">
                            </div>
                            <div class="col-md-8">
                                <div class="card-body">
                                    <h5 class="card-title">Service 02</h5>
                                    <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                        Perspiciatis numquam impedit cupiditate omnis nesciunt dolore delectus quidem
                                        aspernatur ab commodi.</p>
                                    <a href="javascript:void(0)" class="btn btn-dark px-4">Detail</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-4">
                    <div class="card">
                        <div class="row g-0">
                            <div class="col-md-4">
                                <img src="/assets/images/services/03.jpg" class="img-fluid rounded-start h-100"
                                    alt="Card Image" style="object-fit: cover;">
                            </div>
                            <div class="col-md-8">
                                <div class="card-body">
                                    <h5 class="card-title">Service 03</h5>
                                    <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                        Perspiciatis numquam impedit cupiditate omnis nesciunt dolore delectus quidem
                                        aspernatur ab commodi.</p>
                                    <a href="javascript:void(0)" class="btn btn-dark px-4">Detail</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'ServicesSection',
}
</script>
<style>
</style>